@if (currentPartner()?.code === 'msm') {
  <static-header-msm [user]="currentUser()" />
}
@if (loggedIn() === true) {
  <div class="header" [style.top.px]="currentPartner()?.topOffset">
    <div class="bar-wrapper">
      @if ((!simple() || showStatus()) && currentStatus()?.description) {
        <status-bar
          [user]="currentUser()"
          [isEmail]="isStatusBarEmail()"
          [isMobile]="isStatusBarMobile()"
          [status]="currentStatus()"
        />
      }
      @for (task of tasks(); track trackByArchive($index, task)) {
        <archive-bar
          [task]="task"
          (closed)="hideArchive(task)"
          (download)="downloadArchive($event)"
        />
      }
    </div>
    @if (loggedIn() === true && !hideTopBar()) {
      <menutech-navbar
        class="navbar"
        (logout)="logout()"
        [partner]="currentPartner()"
        [lang]="lang()"
        [user]="currentUser()"
        [class.hide]="hideTopNav() && sidePanelVisible()"
        (makeSmall)="isStatusBarMobile() ? toggle() : smaller($event)"
      />
    }
  </div>
}

<mat-sidenav-container
  class="sidenav-container"
  [class.logout]="loggedIn() === false"
  [hasBackdrop]="mode() === 'over'"
  [style.top]="
    !(hideTopNav() && sidePanelVisible())
      ? sidenavTopOffset() + (currentPartner()?.topOffset ?? 0) + 'px'
      : 0 + (currentPartner()?.topOffset ?? 0)
  "
  [style.minHeight]="
    !(hideTopNav() && sidePanelVisible()) ? sidenavContainerHeight() : '100%'
  "
  (backdropClick)="closeNav()"
>
  @if (!simple() && loggedIn() === true) {
    <mat-sidenav
      #sidenav
      class="sidenav"
      [class.small]="small()"
      [fixedInViewport]="true"
      [fixedTopGap]="topOffset()"
      [mode]="mode()"
      [opened]="isOpen()"
      (keydown.escape)="closeNav()"
    >
      <app-navigation
        [defaultTemplates]="defaultTemplates()"
        [lang]="lang()"
        [showModulesLink]="
          !currentPartner()?.hideModulesLink && currentUser()?.role === 0
        "
        [small]="small()"
        [user]="currentUser()"
        (closed)="closeNav()"
        (createMenu)="createMenuFromOnboardingTemplate($event)"
        (hide)="hideOrShow($event)"
        (logout)="logout()"
        (makeSmall)="smaller($event)"
      />
    </mat-sidenav>
  }
  <mat-sidenav-content
    #sidenavContent
    class="sidenav-content"
    id="mat-sidenav-content"
    [class.sidepanel-visible]="sidePanelVisible() && !sidePanelMobileView()"
  >
    <main
      class="app"
      [class]="{
        simple: simple(),
        small: small(),
      }"
      [style.minHeight]="
        !simple() && !hideTopNavigation ? sidenavContainerHeight() : '100%'
      "
    >
      @if (!simple() && !hideTopNavigation) {
        <app-top-navigation
          [style.paddingLeft]="topNavigationCustomLeft() + 'px'"
          [title]="
            pageVariable()
              ? ('app.pages.' + pageVariable() + '.title' | transloco)
              : ''
          "
        />
      }
      <div class="content">
        <router-outlet
          [class.side-panel-shown]="sidePanelVisible() && sidePanelOpened()"
          (activate)="refreshScroll()"
        />
        <div class="loader">
          <spinner />
        </div>
      </div>
      @if (!simple() || showFooter()) {
        <app-footer
          backgroundColor="rgba(221, 221, 221, 0)"
          [lang]="lang()"
          [langSwitcher]="false"
          [style.paddingLeft]="
            (isStatusBarMobile() ? 0 : topNavigationCustomLeft()) + 'px'
          "
        />
      }
    </main>
    @if (isOpen()) {
      <div add-class="noscroll" to="body"></div>
    }
  </mat-sidenav-content>
</mat-sidenav-container>
<side-panel
  #sidePanel
  class="side-panel"
  (visibleEvent)="setSidePanelVisible($event)"
  (mobileViewEvent)="setSidePanelMobileView($event)"
  [style.display]="sidePanelVisible() ? 'block' : 'none'"
  [hidden]="!sidePanelOpened()"
  [topOffset]="topOffset()"
/>

@if (showGlobalSpinner()) {
  <div class="global-spinner">
    <spinner />
  </div>
}

<bottom-block-overlay />
